import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { BookOpen, ArrowRight } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const BooksDecisionBanner = () => {
    const [count, setCount] = useState(0);
    const { pathname } = useLocation();
    useEffect(() => {
        axios.get(`${API_URL}/api/books/my/pending`, { withCredentials: true }).then(r => setCount(r.data.proposed_count || 0)).catch(() => {});
        const onUpd = (e) => setCount(e.detail || 0);
        window.addEventListener('books-updated', onUpd);
        return () => window.removeEventListener('books-updated', onUpd);
    }, [pathname]);
    if (count <= 0) return null;
    return (
        <div className="mb-4 flex flex-wrap items-center gap-3 rounded-xl border border-[#FDE68A] bg-[#FFFBEB] px-4 py-3 text-sm text-[#92400E]" role="status" data-testid="books-decision-banner">
            <BookOpen className="h-5 w-5 shrink-0 text-[#B45309]" />
            <p className="flex-1 min-w-[200px]">You have <b data-testid="books-decision-count">{count}</b> book{count > 1 ? 's' : ''} awaiting your decision — please include the books you want to buy for your child or exclude the rest.</p>
            <Link to="/parent/payments?tab=books" className="inline-flex items-center gap-1 rounded-full bg-[#B45309] px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-[#92400E]" data-testid="books-decision-link">Review books <ArrowRight className="h-3.5 w-3.5" /></Link>
        </div>
    );
};
